/**
 * Orders two cell values the way a German reader expects.
 *
 * `Intl`'s collation is what files "Ärzte" next to "Arzt" rather than behind "Zoo", which is
 * where a comparison of char codes puts every umlaut. Numbers are compared as numbers, and
 * numbers inside a string (`Gruppe 2` before `Gruppe 10`) by the `numeric` collation.
 */
export function compareLocalized(a: unknown, b: unknown): number {
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
    }

    return String(a ?? '').localeCompare(String(b ?? ''), undefined, { numeric: true, sensitivity: 'base' });
}

export default compareLocalized;
